// extracted by mini-css-extract-plugin
export var anchorLink = "h2-example-module--anchor-link--13Bfx";
export var h2 = "h2-example-module--h2--2x-Dp";
export var h2Container = "h2-example-module--h2-container--hhuxj";